"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var querystring_1 = require("querystring");
var cookies_1 = require("./cookies");
var init_1 = require("./init");
var l10n_1 = require("./l10n");
function getCSRFTokenName() {
    return 'X-XSRF-TOKEN';
}
exports.getCSRFTokenName = getCSRFTokenName;
function getCSRFTokenValue() {
    var cookieName = 'XSRF-TOKEN';
    var cookieValue = cookies_1.getCookie(cookieName);
    if (!cookieValue) {
        return '';
    }
    return cookieValue;
}
exports.getCSRFTokenValue = getCSRFTokenValue;
function getCSRFToken() {
    var _a;
    var value = getCSRFTokenValue();
    return value ? (_a = {}, _a[getCSRFTokenName()] = value, _a) : {};
}
exports.getCSRFToken = getCSRFToken;
function omitNil(obj) {
    return lodash_1.omitBy(obj, lodash_1.isNil);
}
exports.omitNil = omitNil;
var DEFAULT_OPTIONS = {
    credentials: 'same-origin',
    method: 'GET',
};
var DEFAULT_HEADERS = {
    Accept: 'application/json',
};
var Request = (function () {
    function Request(url, options) {
        if (options === void 0) { options = {}; }
        this.url = url;
        this.options = options;
        this.isJSON = false;
    }
    Request.prototype.getSubmitData = function (customHeaders) {
        if (customHeaders === void 0) { customHeaders = {}; }
        var url = this.url;
        var options = __assign(__assign({}, DEFAULT_OPTIONS), this.options);
        if (this.data) {
            if (this.data instanceof FormData) {
                options.body = this.data;
            }
            else if (this.isJSON) {
                customHeaders['Content-Type'] = 'application/json';
                options.body = JSON.stringify(this.data);
            }
            else {
                var strData = querystring_1.stringify(omitNil(this.data));
                if (options.method === 'GET') {
                    url += '?' + strData;
                }
                else {
                    customHeaders['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.body = strData;
                }
            }
        }
        options.headers = __assign(__assign({}, DEFAULT_HEADERS), customHeaders);
        return { url: url, options: options };
    };
    Request.prototype.submit = function () {
        var _a = this.getSubmitData(__assign({}, getCSRFToken())), url = _a.url, options = _a.options;
        return window.fetch(init_1.getUrlContext() + url, options);
    };
    Request.prototype.setMethod = function (method) {
        this.options.method = method;
        return this;
    };
    Request.prototype.setData = function (data, isJSON) {
        if (isJSON === void 0) { isJSON = false; }
        if (data) {
            this.data = data;
            this.isJSON = isJSON;
        }
        return this;
    };
    return Request;
}());
function request(url) {
    return new Request(url);
}
exports.request = request;
function corsRequest(url, mode) {
    if (mode === void 0) { mode = 'cors'; }
    var options = { mode: mode };
    var request = new Request(url, options);
    request.submit = function () {
        var _a = this.getSubmitData(), url = _a.url, options = _a.options;
        return window.fetch(url, options);
    };
    return request;
}
exports.corsRequest = corsRequest;
function checkStatus(response, bypassRedirect) {
    return new Promise(function (resolve, reject) {
        if (response.status === HttpStatus.Unauthorized && !bypassRedirect) {
            Promise.resolve().then(function () { return require('./handleRequiredAuthentication'); }).then(function (i) { return i.default(); })
                .then(reject, reject);
        }
        else if (isSuccessStatus(response.status)) {
            resolve(response);
        }
        else {
            reject(response);
        }
    });
}
exports.checkStatus = checkStatus;
function parseJSON(response) {
    return response.json();
}
exports.parseJSON = parseJSON;
function parseText(response) {
    return response.text();
}
exports.parseText = parseText;
function parseError(response) {
    var DEFAULT_MESSAGE = l10n_1.translate('default_error_message');
    return parseJSON(response)
        .then(function (_a) {
        var errors = _a.errors;
        return errors.map(function (error) { return error.msg; }).join('. ');
    })
        .catch(function () { return DEFAULT_MESSAGE; });
}
exports.parseError = parseError;
function get(url, data, bypassRedirect) {
    return request(url)
        .setData(data)
        .submit()
        .then(function (response) { return checkStatus(response, bypassRedirect); });
}
exports.get = get;
function getJSON(url, data, bypassRedirect) {
    return get(url, data, bypassRedirect).then(parseJSON);
}
exports.getJSON = getJSON;
function getText(url, data, bypassRedirect) {
    return get(url, data, bypassRedirect).then(parseText);
}
exports.getText = getText;
function getCorsJSON(url, data) {
    return corsRequest(url)
        .setData(data)
        .submit()
        .then(function (response) {
        if (isSuccessStatus(response.status)) {
            return parseJSON(response);
        }
        else {
            return Promise.reject(response);
        }
    });
}
exports.getCorsJSON = getCorsJSON;
function postJSON(url, data, bypassRedirect) {
    return request(url)
        .setMethod('POST')
        .setData(data)
        .submit()
        .then(function (response) { return checkStatus(response, bypassRedirect); })
        .then(parseJSON);
}
exports.postJSON = postJSON;
function postJSONBody(url, data, bypassRedirect) {
    return request(url)
        .setMethod('POST')
        .setData(data, true)
        .submit()
        .then(function (response) { return checkStatus(response, bypassRedirect); })
        .then(parseJSON);
}
exports.postJSONBody = postJSONBody;
function post(url, data, bypassRedirect) {
    return new Promise(function (resolve, reject) {
        request(url)
            .setMethod('POST')
            .setData(data)
            .submit()
            .then(function (response) { return checkStatus(response, bypassRedirect); })
            .then(function () { return resolve(); }, reject);
    });
}
exports.post = post;
function tryRequestAgain(repeatAPICall, tries, stopRepeat, repeatErrors, lastError) {
    if (repeatErrors === void 0) { repeatErrors = []; }
    tries.max--;
    if (tries.max !== 0) {
        return new Promise(function (resolve) {
            setTimeout(function () { return resolve(requestTryAndRepeatUntil(repeatAPICall, tries, stopRepeat, repeatErrors)); }, tries.max > tries.slowThreshold ? 500 : 3000);
        });
    }
    return Promise.reject(lastError);
}
function requestTryAndRepeatUntil(repeatAPICall, tries, stopRepeat, repeatErrors) {
    if (repeatErrors === void 0) { repeatErrors = []; }
    return repeatAPICall().then(function (r) {
        if (stopRepeat(r)) {
            return r;
        }
        return tryRequestAgain(repeatAPICall, tries, stopRepeat, repeatErrors);
    }, function (error) {
        if (repeatErrors.length === 0 || repeatErrors.includes(error.status)) {
            return tryRequestAgain(repeatAPICall, tries, stopRepeat, repeatErrors, error);
        }
        return Promise.reject(error);
    });
}
exports.requestTryAndRepeatUntil = requestTryAndRepeatUntil;
function isSuccessStatus(status) {
    return status >= 200 && status < 300;
}
exports.isSuccessStatus = isSuccessStatus;
var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["Ok"] = 200] = "Ok";
    HttpStatus[HttpStatus["Created"] = 201] = "Created";
    HttpStatus[HttpStatus["MultipleChoices"] = 300] = "MultipleChoices";
    HttpStatus[HttpStatus["MovedPermanently"] = 301] = "MovedPermanently";
    HttpStatus[HttpStatus["Found"] = 302] = "Found";
    HttpStatus[HttpStatus["BadRequest"] = 400] = "BadRequest";
    HttpStatus[HttpStatus["Unauthorized"] = 401] = "Unauthorized";
    HttpStatus[HttpStatus["Forbidden"] = 403] = "Forbidden";
    HttpStatus[HttpStatus["NotFound"] = 404] = "NotFound";
    HttpStatus[HttpStatus["InternalServerError"] = 500] = "InternalServerError";
    HttpStatus[HttpStatus["NotImplemented"] = 501] = "NotImplemented";
    HttpStatus[HttpStatus["BadGateway"] = 502] = "BadGateway";
    HttpStatus[HttpStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatus[HttpStatus["GatewayTimeout"] = 504] = "GatewayTimeout";
})(HttpStatus = exports.HttpStatus || (exports.HttpStatus = {}));
//# sourceMappingURL=request.js.map